// extracted by mini-css-extract-plugin
export default {"NotFound":"styles_NotFound__GB28Z","NotFoundWrapper":"styles_NotFoundWrapper__i5jwi"};